/**
 * Auto-clear utility for dependent option fields.
 *
 * When a parent field changes, checks if any dependent fields' current values
 * are still valid. If not, resets to the first available option and returns
 * a description of what changed.
 */

import type { OptionSchemaEntry } from '../schemas/feature.schemas';

interface AutoClearResult {
  values: Record<string, unknown>;
  note: string | null;
}

export function autoClearDependents(
  changedKey: string,
  changedValue: unknown,
  currentValues: Record<string, unknown>,
  schema: Record<string, OptionSchemaEntry>,
): AutoClearResult {
  const next = { ...currentValues, [changedKey]: changedValue };
  let note: string | null = null;

  for (const [depKey, depEntry] of Object.entries(schema)) {
    if (depEntry.depends_on === changedKey && depEntry.enum_map) {
      const available = depEntry.enum_map[String(changedValue as string | number | boolean)];
      if (available && !available.includes(String(next[depKey]))) {
        const oldValue = String(next[depKey]);
        next[depKey] = available[0];
        note = `${depEntry.label} changed — ${oldValue} is not available in ${String(changedValue as string | number | boolean)}`;
      }
    }
  }

  return { values: next, note };
}
